/**
 * Old addresses → their 2026-10 homes (phase 2). Bookmarks, notification e-mails and search results keep working.
 *   /transacties[?…]         → /documenten/transacties[?…]   (full transaction list, reached from 资料 → 银行流水)
 *   /bedrijven               → /instellingen/bedrijven
 *   /bedrijven/:id           → /instellingen/bedrijven/:id
 *   /bedrijven/:id/:quarter  → /aangiftes/:id/:QUARTER        (shareable return link, §4.3)
 *   /logboek                 → /instellingen/logboek
 */
import { Navigate, useLocation } from 'react-router-dom';

export function legacyTarget(pathname: string, search = ''): string | null {
  const p = pathname.replace(/\/+$/, '') || '/';
  if (p === '/transacties') return `/documenten/transacties${search}`;
  if (p === '/logboek') return `/instellingen/logboek${search}`;
  if (p === '/bedrijven') return `/instellingen/bedrijven${search}`;
  let m = /^\/bedrijven\/([^/]+)$/.exec(p);
  if (m) return `/instellingen/bedrijven/${m[1]}${search}`;
  m = /^\/bedrijven\/([^/]+)\/([^/]+)$/.exec(p);
  if (m) return `/aangiftes/${m[1]}/${m[2].toUpperCase()}`;
  return null;
}

export function LegacyRedirect() {
  const { pathname, search } = useLocation();
  return <Navigate to={legacyTarget(pathname, search) ?? '/'} replace />;
}
